import { TaskAction } from '@types';
import { useStore } from 'effector-react';
import { useQuery } from 'react-query';
import fetchRunningTask from '../actions/fetchRunningTask';
import matrixTask from '../actions/matrixTask';
import { watermarkSetting } from '../actions/showWarningModals';
import { baseSpaceCheck, remainSpaceCheck } from '../actions/spaceCheck';
import UploadButton from '../components/UploadButton';
import { $libAlbumId } from '../stores/libState';
import { $libUploadingMatrix } from '../stores/libUploading';
import libSelectFiles from '../utils/libSelectFiles';

function UploadButtonMatrix() {
  const albumId = useStore($libAlbumId);
  useQuery('runningTaskMatrix', () => fetchRunningTask('matrix'), {
    onSuccess: (data = []) => {
      data.forEach((x) => {
        if (x.action === TaskAction.new) {
          $libUploadingMatrix.api.addRunningTask({
            name: x.name,
            libId: x.id,
            progress: '制作中',
          });
        }
      });
    },
  });
  const itemMap = useStore($libUploadingMatrix.store);

  const handleUplpad = async () => {
    await baseSpaceCheck();
    const { watermarked } = await watermarkSetting();
    const { files, size } = await libSelectFiles({ accept: ['image/jpeg'] });
    await remainSpaceCheck(size);
    await matrixTask({ files, albumId, watermarked });
  };

  return (
    <UploadButton
      className="ml-auto"
      itemMap={itemMap}
      onClick={handleUplpad}
    />
  );
}

export default UploadButtonMatrix;
